import { render, staticRenderFns } from "./AmsCard.vue?vue&type=template&id=734eb6ab&"
import script from "./AmsCard.vue?vue&type=script&lang=js&"
export * from "./AmsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports